// extracted by mini-css-extract-plugin
module.exports = {"ImageCropperWrapper":"ImageCropper_ImageCropperWrapper__zmhH_"};